<div>
  <h5 class="font-weight-bold my-4" i18n> Order Information </h5>
</div>
<div *ngIf="masterOrderData$ | async as masterOrderData" class="row">
  <div class="col-12 col-md-5 border-r-1 pr-md-5">
    <div
      class="d-flex justify-content-between"
      *ngIf="masterOrderData.hostessName; else consultantName"
    >
      <label i18n class="text-uppercase text-double-dot">Hostess Name</label>
      <i class="font-weight-bold">
        {{ masterOrderData.hostessName }}
      </i>
    </div>
    <ng-template #consultantName>
      <div class="d-flex justify-content-between">
        <label i18n class="text-uppercase text-double-dot">Consultant Name</label>
        <i class="font-weight-bold"> {{ masterOrderData.consultantName }} </i>
      </div>
    </ng-template>
    <div class="d-flex justify-content-between">
      <label i18n class="text-uppercase text-double-dot">Order Number</label>
      <span>
        {{ masterOrderData.orderNumber }}
      </span>
    </div>
    <div class="d-flex justify-content-between">
      <label i18n class="text-uppercase text-double-dot">Date Received</label>
      <span>
        {{ masterOrderData.receivedDate | date: 'longDate' }}
      </span>
    </div>
  </div>

  <div class="col-12 col-md-5 pl-md-5">
    <div class="d-flex justify-content-between">
      <label i18n class="text-uppercase text-double-dot">Total Order Amount</label>
      <span>
        {{ masterOrderData.totalOrderAmount | phCurrency }}
      </span>
    </div>
    <div class="d-flex justify-content-between">
      <label i18n class="text-uppercase text-double-dot">Payment Received</label>
      <span>
        {{ masterOrderData.paymentReceived | phCurrency }}
      </span>
    </div>
    <div class="d-flex justify-content-between">
      <label i18n class="text-uppercase text-double-dot font-weight-bold">Balance Due</label>
      <span class="font-weight-bold">
        {{ masterOrderData.balanceDue | phCurrency }}
      </span>
    </div>
  </div>
</div>
